import React, { ReactNode } from 'react'
import './doc-card.scss'
import { NavLink } from 'react-router-dom'
import { Status } from '../../hooks'
import classNames from 'classnames'

const Anchor = ({ to, children }: { to: string; children: ReactNode }) => (
  <a href={to}>{children}</a>
)

export const DocCard = ({
  title,
  icon,
  link,
  status = 'SUCCESS',
  version = ''
}: {
  title: string
  icon: ReactNode
  link: string | null
  status?: Status
  version?: string
}) => {
  const external = link?.match(/^https?:\/\//)

  const Wrapper = external ? Anchor : NavLink

  const ready = !['IDLE', 'LOADING'].includes(status)

  return (
    <div
      className={classNames('doc-card', {
        'doc-card--loading': !ready,
        'doc-card--error': status === 'ERROR' || (ready && !link)
      })}
    >
      <Wrapper to={link ?? '#'}>
        <div className="doc-card__version">{version}</div>
        <div className="doc-card__icon">{icon}</div>
        <div className="doc-card__title">{title}</div>
      </Wrapper>
    </div>
  )
}
